import { useQuery } from '@tanstack/react-query';
import { fetchBrands } from './brands.api';

export const BRANDS_QUERY_KEY = ['brands'] as const;

const STALE_TIME_MS = 1000 * 60 * 5;
const GC_TIME_MS = 1000 * 60 * 15;

export function useBrandsQuery() {
  return useQuery({
    queryKey: BRANDS_QUERY_KEY,
    queryFn: fetchBrands,
    staleTime: STALE_TIME_MS,
    gcTime: GC_TIME_MS,
  });
}
